/* eslint-disable no-redeclare */
/* eslint-disable no-var */
import { compose } from 'lodash/fp';

function convert_youtube(input) {
  const pattern = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(\S+)/g;
  if (pattern.test(input)) {
    const replacement = 'https://www.youtube.com/embed/$1';
    var input = input.replace(pattern, replacement);
    // For start time, turn get param & into ?

    var input = input.replace('&amp;t=', '?t=');
  }
  return input;
}

function convert_vimeo(input) {
  const pattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(\S+)/g;
  if (pattern.test(input)) {
    const replacement = 'https://player.vimeo.com/video/$1';
    var input = input.replace(pattern, replacement);
  }
  return input;
}
// https://gist.github.com/goosehub/0578867f7f5524d0b94ec13bbbf2cde2
export const convertVideoLink = compose(convert_vimeo, convert_youtube);
